import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment-timezone';
import { DropdownButton, MenuItem } from 'react-bootstrap';

import Safe from './Safe';
import SubEvent from './SubEvent';
import Slider from './Slider';
import Comments from './Comments';
import Tags from './Tags';
import Assignee from './Assignee';

import { render } from '../../lib/helpers';
import { colors } from '../../lib/colors';

class Card extends Component {
  constructor(props) {
    super(props);
    this.state = {
      flags: false,
      comments: '',
    };

    this.updateAssignedUsers = this.updateAssignedUsers.bind(this);
  }

  highlightFlags(state) {
    this.setState({ flags: state });
  }

  updateAssignedUsers(assignee = []) {
    const { update, finding } = this.props;
    update({
      ...finding,
      assignee,
    });
  }

  render() {
    const {
      finding: {
        id,
        name,
        analysis,
        created,
        tags = [],
        confirmation_workflow = [],
        mitigation_workflow = [],

        assignee,
        requestor = {},
        eventType,
        priority,
        type,
      },
      finding = {},
      assignableUsers = [],
      viewDetail,
      viewTimeline,
      inverted = false,
      expanded = false,
      role = '',
    } = this.props;

    const {
      flags = false,
      comments = '',
    } = this.state;

    return (
      <div className='event-card' data-inverted={inverted}>
        <span className='d-flex'>
          <span
            className='card-flags'
            onFocus={this.highlightFlags.bind(this, true)}
            onBlur={this.highlightFlags.bind(this, false)}
            onMouseEnter={this.highlightFlags.bind(this, true)}
            onMouseLeave={this.highlightFlags.bind(this, false)}
          >
            <Safe
              render
              path='_type'
              value={type}
              title={render({
                path: 'type',
                value: type,
                html: false,
              })}
              style={{ color: 'black', backgroundColor: colors.type[type] }}
            />
            <Safe
              render
              path='_priority'
              value={priority}
              title={render({
                path: 'priority',
                value: priority,
                html: false,
              })}
              style={{ color: 'black', backgroundColor: colors.priority[priority] }}
            />
          </span>
          <span
            className='card-flags card-flags-explanations'
            onFocus={this.highlightFlags.bind(this, true)}
            onBlur={this.highlightFlags.bind(this, false)}
            onMouseEnter={this.highlightFlags.bind(this, true)}
            onMouseLeave={this.highlightFlags.bind(this, false)}
            style={{ display: flags ? 'block' : 'none' }}
          >
            <Safe
              render
              safe
              path='flagTypes'
              value='type'
            />
            <Safe
              render
              safe
              path='flagTypes'
              value='priority'
            />
            <Safe
              render
              safe
              path='flagTypes'
              value='confidence'
            />
            <Safe
              render
              safe
              path='flagTypes'
              value='severity'
            />
          </span>
          <span className='card-content container d-flex flex-column'>
            <div className='card-content-header row d-flex'>
              <span
                className='card-content-header-left'
                style={{
                  flexGrow: 1,
                  width: '80%',
                }}
              >
                <div className='title'>{name}</div>
                <Tags event={this.props} tags={tags} />
              </span>
              <span
                className='card-content-header-right'
                style={{
                  width: '20%',
                }}
              >
                <DropdownButton
                  noCaret
                  pullRight
                  bsStyle='primary'
                  title={
                    <i
                      style={{ padding: '10px' }}
                      className='fas fa-ellipsis-v'
                    />
                  }
                  id={`detail-dropdown-${id}`}
                  style={{
                    backgroundColor: 'transparent',
                    border: 'none',
                    position: 'relative',
                    right: '-10px',
                  }}
                  ref={(c) => { this.orgMenu = c; }}
                >
                  <MenuItem
                    eventKey={0}
                    onClick={() => {
                      viewDetail(finding);
                      document.dispatchEvent(new MouseEvent('click'));
                    }}
                  >
                    View Detail
                  </MenuItem>
                  <MenuItem
                    eventKey={0}
                    onClick={() => {
                      document.dispatchEvent(new MouseEvent('click'));
                      viewTimeline(finding);
                    }}
                  >
                    Jump to Timeline
                  </MenuItem>
                </DropdownButton>
                {!expanded && <div style={{ fontSize: '0.6rem' }}>{moment(created).format('MMM D')}</div>}
              </span>
            </div>
            <div className='card-content-info row'>
              <span className='card-content-info-left'>
                <Assignee
                  assignee={assignee}
                  assignableUsers={assignableUsers}
                  update={this.updateAssignedUsers}
                />
              </span>
              <span className='card-content-info-middle'>
                <div>Type: {type}</div>
              </span>
              <span className='card-content-info-right' style={{ textAlign: 'left' }}>
                {expanded && <div>Date: {moment(created).format('MMMM D')}</div>}
                {!expanded && <div>Asset type | Asset Name w/Link</div>}
              </span>
            </div>
            {!expanded &&
              <div className='card-content-requestor row'>
                <span className='card-content-requestor col'>
                  <Safe
                    text={requestor.firstname}
                    className='uppercase'
                  />
                  <span>&nbsp;</span>
                  <Safe
                    text={requestor.lastname}
                    className='uppercase'
                  />
                  <span>&nbsp;has requested a&nbsp;</span>
                  <Safe
                    render
                    path='requestType'
                    value={requestor.type}
                    className='uppercase'
                  />
                  <span>&nbsp;for this&nbsp;</span>
                  <Safe
                    render
                    path='eventType'
                    value={eventType}
                    className='uppercase'
                  />
                </span>
              </div>
            }
            {!expanded &&
              <div className='card-content-sub-events row' data-expanded={expanded}>
                <span className='col'>
                  <div className='analysis'>{analysis}</div>
                  {role === 'analyst' ?
                    confirmation_workflow.map((s, i) => <SubEvent key={i} workflows={JSON.parse(s)} />) : null
                  }
                  {role === 'responder' ?
                    mitigation_workflow.map((s, i) => <SubEvent key={i} workflows={JSON.parse(s)} />) : null
                  }
                </span>
              </div>
            }
            {!expanded &&
              <div className='card-content-message row'>
                <span className='col'>
                  <textarea placeholder='Write a message...' />
                  <i className='attachment icon fas fa-paperclip' />
                </span>
              </div>
            }
          </span>
        </span>
        {expanded &&
          <div className='row card-content-expanded' style={{ display: 'block' }}>
            <div className='col-12'>
              <div className='column-header'>Next Steps</div>
              <div
                className='col-12 current-action'
              >
                Perform MITIGATION REVIEW as quickly as possible. Please leave detailed notes.
              </div>
            </div>
            <div className='col-12' style={{ marginTop: '32px' }}>
              <div
                style={{
                  width: '50%',
                  display: 'inline-block',
                  paddingRight: '10px',
                }}
              >
                <Slider
                  title={
                    <Safe
                      render
                      safe
                      path='workflow'
                      value='accuracyTitle'
                    />
                  }
                  description={
                    <Safe
                      render
                      safe
                      path='workflow'
                      value='accuracyDescription'
                    />
                  }
                  position={3}
                />
              </div>
              <div
                style={{
                  width: '50%',
                  display: 'inline-block',
                  paddingLeft: '10px',
                }}
              >
                <Slider
                  title={
                    <Safe
                      render
                      safe
                      path='workflow'
                      value='relevanceTitle'
                    />
                  }
                  description={
                    <Safe
                      render
                      safe
                      path='workflow'
                      value='relevanceDescription'
                    />
                  }
                  position={2}
                />
              </div>
            </div>
            <div className='col-12' style={{ marginTop: '32px' }}>
              <Comments
                title={
                  <Safe
                    render
                    safe
                    path='general'
                    value='comments'
                  />
                }
                comments={comments}
                update={(value) => { this.setState({ comments: value }); }}
              />
            </div>
          </div>
        }
      </div>
    );
  }
}

Card.propTypes = {
  finding: PropTypes.shape({
    id: PropTypes.string,
    title: PropTypes.string,
    date: PropTypes.string,
    tags: PropTypes.instanceOf(Array),
    assignee: PropTypes.instanceOf(Array),
    requestor: PropTypes.shape({}),
    subEvents: PropTypes.instanceOf(Array),
    orgId: PropTypes.string,
    eventType: PropTypes.string,
    priorityLevel: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    confidence: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    severity: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    type: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  }),
  viewDetail: PropTypes.func,
  viewTimeline: PropTypes.func,
  inverted: PropTypes.bool,
  expanded: PropTypes.bool,
  assignableUsers: PropTypes.instanceOf(Array),
  update: PropTypes.func.isRequired,
  role: PropTypes.string,
};

Card.defaultProps = {
  finding: {
    id: '',
    title: '',
    date: '',
    tags: [],
    assignee: [],
    subEvents: [],
    requestor: {},
    orgId: '',
    type: '?',
    priority: '?',
    confidence: '?',
    severity: '?',
  },
  inverted: false,
  expanded: false,
  viewDetail: () => {},
  viewTimeline: () => {},
  assignableUsers: [],
  role: '',
};

export default Card;



// WEBPACK FOOTER //
// ./src/views/Components/Card.js